import { render, staticRenderFns } from "./AppsBlock.vue?vue&type=template&id=8a17914c&"
import script from "./AppsBlock.vue?vue&type=script&lang=js&"
export * from "./AppsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports